import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const STATUS_CONFIG = [
  { key: "open", label: "Open", color: "rgb(181, 255, 144)" },
  { key: "in-progress", label: "In Progress", color: "rgb(152, 205, 255)" },
  { key: "resolved", label: "Resolved", color: "rgb(255, 160, 162)" },
  { key: "closed", label: "Closed", color: "rgb(219, 219, 219)" },
];

export function PieChart({ ticketsData }) {
  const tickets = Array.isArray(ticketsData) ? ticketsData : [];

  const statusCounts = tickets.reduce((acc, ticket) => {
    const status = ticket?.status;
    if (status) {
      acc[status] = (acc[status] || 0) + 1;
    }
    return acc;
  }, {});

  const chartEntries = STATUS_CONFIG.map(({ key, label, color }) => ({
    label,
    count: statusCounts[key] || 0,
    color,
  })).filter((entry) => entry.count > 0);

  const hasData = chartEntries.length > 0;

  const data = {
    labels: hasData ? chartEntries.map((entry) => entry.label) : ["No Tickets"],
    datasets: [
      {
        label: "# of Tickets",
        data: hasData ? chartEntries.map((entry) => entry.count) : [1],
        backgroundColor: hasData
          ? chartEntries.map((entry) => entry.color)
          : ["rgba(200, 200, 200, 1)"],
        borderColor: hasData
          ? chartEntries.map((entry) => entry.color)
          : ["rgba(200, 200, 200, 1)"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  return (
    <div className="analytics-chart">
      <div className="analytics-chart__canvas">
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
}
